var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('small',{staticClass:"label-info",style:({
    background: _vm.getLabelsInfo.backgroundColor || _vm.defaultColors.back,
    color: _vm.getLabelsInfo.foregroundColor || _vm.defaultColors.front,
  })},[_vm._v("\n  "+_vm._s(_vm.getLabelsInfo.title))])}
var staticRenderFns = []

export { render, staticRenderFns }